import { useEffect, useRef, useState, useCallback } from "react";
import { api } from "../api/client";

// Hook que polla /entregas/oferta-pendente a cada 2s pra detectar ofertas
// novas pro freteiro logado (estilo Uber: o app sempre escuta enquanto
// online, e quando chega uma oferta abre modal full-screen automaticamente).
//
// Polling de 2s eh sub-Uber (Uber tem WebSocket), mas dado que nosso TTL eh
// 20s, isso garante <= 2s de latencia entre criar a oferta e o freteiro ver.
//
// onNova(oferta): callback disparado quando detecta oferta nova (id mudou).
//                 UI usa pra abrir modal/tocar som.

export const useOfertaFreteiro = ({ ativo = true, onNova, intervaloMs = 1500 } = {}) => {
  const [oferta, setOferta] = useState(null);
  const [carregando, setCarregando] = useState(false);
  const ultimoIdRef = useRef(null);

  const refresh = useCallback(async () => {
    if (!ativo) return;
    setCarregando(true);
    try {
      const r = await api.ofertaPendenteFreteiro();
      const nova = r?.oferta || null;
      if (nova?.id && nova.id !== ultimoIdRef.current) {
        ultimoIdRef.current = nova.id;
        try { onNova?.({ oferta: nova, entrega: r.entrega, pedido: r.pedido }); } catch {}
      }
      if (!nova) ultimoIdRef.current = null;
      setOferta(r);
    } catch (e) {
      // silencioso - 401 quando user nao eh freteiro habilitado
    } finally {
      setCarregando(false);
    }
  }, [ativo, onNova]);

  useEffect(() => {
    if (!ativo) {
      setOferta(null);
      ultimoIdRef.current = null;
      return;
    }
    refresh();
    const iv = setInterval(refresh, intervaloMs);
    return () => clearInterval(iv);
  }, [ativo, intervaloMs, refresh]);

  const aceitar = useCallback(async () => {
    if (!oferta?.oferta?.id) return null;
    const r = await api.aceitarOferta(oferta.oferta.id);
    ultimoIdRef.current = null;
    setOferta(null);
    return r;
  }, [oferta]);

  const recusar = useCallback(async (motivo) => {
    if (!oferta?.oferta?.id) return null;
    const r = await api.recusarOferta(oferta.oferta.id, motivo);
    ultimoIdRef.current = null;
    setOferta(null);
    return r;
  }, [oferta]);

  return { oferta, carregando, refresh, aceitar, recusar };
};
